<template>
  <ContainerBasic container-type="FULL_WIDTH" class="pt-md md:pt-xl">
    <ContainerBasic
      v-if="props.blockData.headline || props.blockData.text"
      container-type="CONTENT"
      class="px-sm xl:px-0"
    >
      <Headline
        v-if="props.blockData.headline"
        level="h2"
        :class="{ 'mb-md': props.blockData.text }"
        :headline="props.blockData.headline"
        :has-decoration="true"
      />

      <WYSIWYGContentRaw
        v-if="props.blockData.text"
        inner-classes="!px-0"
        :content="props.blockData.text"
      ></WYSIWYGContentRaw>
    </ContainerBasic>

    <ContainerBasic container-type="PAGE" class="mt-md md:mt-xl px-sm xl:px-0">
      <LazyListSlider :block-data="blockData" :show-slides="4" />
    </ContainerBasic>
  </ContainerBasic>
</template>

<script setup lang="ts">
import LazyListSlider from '../components/vdv/teamLazyListSlider.vue';
import ContainerBasic from '@/components/components/container-basic.vue';
import { Headline, WYSIWYGContentRaw } from '@/complib';
import type { TeamData } from '../blockType';

const props = defineProps({
  blockData: {
    type: Object as PropType<TeamData>,
    required: true,
    default: {} as TeamData,
  },
});
</script>
